/**
 * Best-effort HTTP status code from a thrown fetch error (ofetch `FetchError`,
 * `createError` result, or a raw Response-like object). Returns `undefined`
 * for non-HTTP failures such as timeouts/aborts or network errors.
 */
export function extractFetchErrorStatusCode(
  error: unknown
): number | undefined {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  const candidate = error as {
    statusCode?: unknown;
    status?: unknown;
    response?: { status?: unknown };
  };

  const raw =
    candidate.statusCode ?? candidate.status ?? candidate.response?.status;

  const code = Number(raw);
  return Number.isInteger(code) && code > 0 ? code : undefined;
}
